<script lang="ts" setup></script>

<template>
    <div class="flex-1 flex flex-col h-full divide-y divide-gray-300">
        <div class="flex flex-col p-4">
            <h1 class="text-xl font-medium">Preferences</h1>
            <p class="opacity-50">Manage your preferences</p>
        </div>
        <div class="px-4 py-2">
            <p class="font-medium">Appearance</p>
        </div>
        <div class="p-4">
            <Placeholder class="w-full h-16" />
        </div>
        <div class="p-4">
            <Placeholder class="w-full h-16" />
        </div>
        <div class="p-4">
            <Placeholder class="w-full h-16" />
        </div>
        <div class="px-4 py-2">
            <p class="font-medium">Language & Time</p>
        </div>
        <div class="p-4">
            <Placeholder class="w-full h-16" />
        </div>
        <div class="p-4">
            <Placeholder class="w-full h-16" />
        </div>
    </div>
</template>
